const data = {
  disclaimer:
    "Karuna a website and application from Path Check Inc, dba PathCheck Foundation (“PCF”), a US non-profit corporation. PCF partnered Covid Survivor Force India (CSFI), an unincorporated organization  connecting people.  PCF shall not be held liable for any loss that you may incur by relying on this information or app.",
};

export default data;
